export const MAX_NODES_IN_BREADCRUMB = 4;

export const ITEM_SESSION_STORAGE_BLOCK_NAVIGATION = 'blockNavigation';
export const BLOCK_NAVIGATION_TRUE = 'true';
export const BLOCK_NAVIGATION_FALSE = 'false';

export const ITEM_SESSION_STORAGE_CRUMBS = 'crumbs';

export const CUSTOM_EVENT_SLICE_CRUMB = 'sliceCrumb';
